export async function sendOrderForm(data) {
  const res = await fetch("/.netlify/functions/send-form", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });

  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || "Помилка відправки");
  }

  return res.json();
}

export async function sendContactForm(data) {
  const { subject, topic, ...rest } = data;
  const payload = { ...rest, topic: topic ?? subject };

  const res = await fetch("/.netlify/functions/send-contact", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || "Помилка відправки");
  }

  return res.json();
}
